"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPS_WIDGET_ID = void 0;
exports.NPS_WIDGET_ID = '7328d246-1403-4553-993c-83e0ac79f98e';
//# sourceMappingURL=constants.js.map